module.exports = __webpack_public_path__ + "static/media/payment-instructions.b6436255.svg";